export default __webpack_public_path__ + "static/media/ic-file-blue.4de3b68a.svg";